class CollectionGridItem extends HTMLElement {
  constructor() {
    super();

    this.mainCollection = null;
    this.productGrid = null;
    this.sourceItem = null;
    this.bannerId = '';
    this.desktopPosition = 0;
    this.mobilePosition = 0;
    this.mutationObserver = null;
    this.frameId = null;

    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.mainCollection = this.closest('[js-hb-main-collection]') || document.querySelector('[js-hb-main-collection]');
    this.productGrid = this.mainCollection?.querySelector('[js-product-grid]') || null;
    this.sourceItem = this.querySelector('.product-grid__item');
    this.bannerId = this.sourceItem?.dataset.productId || `custom-banner-${Math.random().toString(36).slice(2)}`;
    this.desktopPosition = Number.parseInt(this.dataset.hbPositionDesk || '', 10) || 0;
    this.mobilePosition = Number.parseInt(this.dataset.hbPositionMob || '', 10) || 0;

    this.startObserving();
    window.addEventListener('resize', this.handleResize);
    this.scheduleAppend();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);

    if (this.frameId) {
      cancelAnimationFrame(this.frameId);
      this.frameId = null;
    }

    this.mutationObserver?.disconnect();
    this.mutationObserver = null;
    this.removeInjectedItem();
  }

  handleResize() {
    this.scheduleAppend();
  }

  startObserving() {
    if (!this.mainCollection) return;

    this.mutationObserver?.disconnect();
    this.mutationObserver = new MutationObserver(() => {
      this.productGrid = this.mainCollection?.querySelector('[js-product-grid]') || null;
      this.scheduleAppend();
    });

    this.mutationObserver.observe(this.mainCollection, {
      childList: true,
      subtree: true,
    });
  }

  scheduleAppend() {
    if (this.frameId) cancelAnimationFrame(this.frameId);

    this.frameId = requestAnimationFrame(() => {
      this.frameId = null;
      this.appendGridItem();
    });
  }

  getCurrentPosition() {
    return document.documentElement.clientWidth > 749 ? this.desktopPosition : this.mobilePosition;
  }

  getProductItems() {
    if (!this.productGrid) return [];

    return Array.from(this.productGrid.children).filter((item) => {
      return item.matches('li.product-grid__item') && item.dataset.collectionBannerInjected !== 'true';
    });
  }

  getInjectedItem() {
    if (!this.productGrid) return null;

    return this.productGrid.querySelector(`[data-collection-banner-source="${this.bannerId}"]`);
  }

  removeInjectedItem() {
    this.getInjectedItem()?.remove();
  }

  isPlacedBeforeTarget(injectedItem, targetProductItem) {
    let sibling = injectedItem.nextElementSibling;

    while (sibling?.dataset.collectionBannerInjected === 'true') {
      sibling = sibling.nextElementSibling;
    }

    return sibling === targetProductItem;
  }

  appendGridItem() {
    if (!this.mainCollection || !this.sourceItem) return;

    this.productGrid = this.mainCollection.querySelector('[js-product-grid]');

    if (!this.productGrid) {
      this.removeInjectedItem();
      return;
    }

    const position = this.getCurrentPosition();
    const targetProductItem = this.getProductItems()[position - 1];
    const existingInjectedItem = this.getInjectedItem();

    // if (!targetProductItem) {
    //   existingInjectedItem?.remove();
    //   return;
    // }

    if (!targetProductItem) {
      const items = this.getProductItems();

      if (!items.length) return;

      // ✅ if already exists at correct place → STOP
      if (existingInjectedItem) {
        const lastItem = items[items.length - 1];

        if (existingInjectedItem.previousElementSibling === lastItem) {
          return; // already correctly placed
        }

        existingInjectedItem.remove(); // move it instead of duplicating
      }

      const injectedItem =
        existingInjectedItem || this.sourceItem.cloneNode(true);

      injectedItem.dataset.collectionBannerInjected = 'true';
      injectedItem.dataset.collectionBannerSource = this.bannerId;

      // 👉 Append at end
      items[items.length - 1].insertAdjacentElement(
        'afterend',
        injectedItem
      );

      return;
    }

    if (existingInjectedItem && this.isPlacedBeforeTarget(existingInjectedItem, targetProductItem)) return;

    const injectedItem = existingInjectedItem || this.sourceItem.cloneNode(true);
    injectedItem.dataset.collectionBannerInjected = 'true';
    injectedItem.dataset.collectionBannerSource = this.bannerId;

    targetProductItem.insertAdjacentElement('beforebegin', injectedItem);
  }
}

if (!customElements.get('collection-grid-item')) {
  customElements.define('collection-grid-item', CollectionGridItem);
}
